export default __webpack_public_path__ + "static/media/fridge1-after2-1920w.5b93d6ff.webp";